import { createMachine, interpret } from '@xstate/fsm';
import { TutorialServices } from '../services/TutorialServices';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { completeTutorialStep } from '../tutorial.util';
import * as Tutorial from 'src/replicant/tutorial';
import statePromise from 'src/lib/statePromise';
import PopupMonitor from 'src/game/logic/PopupMonitor';

export function getTeamsTutorialFSM(services: TutorialServices) {
  const machine = interpret(
    createMachine(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QBUwEMC2sB0B7ADmAHaqYCSRALgE64DEl6GFNuAwgDa6yQDaADAF1EofNwCWlcbiIiQAD0QAmfgFZsSpQDZVWpaoA0IAJ6IAjPwAs2Vfzv8tATiUBmLU-6OAvl6OkseIREAGLU4sQQsACyxACudABmYRHRcQDyQXxCcmKwktKySAqIqgDs1gAcVloVpYYm5lY29haqZo5t+lo+fkw4BMT+AAoEsfgMTCP4YxnEWcJFufkycooIjlouGhaO-BWqlqWaqhVGpggW1rZ2re2duj0g-v1B-gAi4rAAxrgAbmDUYwMNAAIzYAAs0EQYBABAtRBIpCsimszG4KtgKi5VLsKmZSi5HHVSmdGld7A5nG4PN5fE8+tgfhh8BwwIxkLFKLgwmgOAxOdzxLy2LhmazGHCcoiCqtzE5StgtJYKpY9vjCcTSRcmtc7E5XO5drS6URcBA4HJnlK8kjCqA1gBaLRap2PZ6BQZMFi0a3LO3FBCWJRavHNez66lGt0MgYhZJESIxIixX222UIFwVRwaPH6ENmMN6qmGzzRzAvT2YKZjVMylGIUq1bD4swqrRWI76U4NBCh3WUg00ssBWPvT4-f6A2vI+3mMzubClfguTy6AlEsr5wsDyOlunupkstlgDlcnkcaf+1GqJQFyzt3HqjcknutbAUncl2m9cvYBLiIheUvdNWyxd8zFUHE1w1TdXzUd8KQjL8fB8IA */
        context: {},
        id: 'Teams',
        initial: 'openTeamIntro',
        states: {
          openTeamIntro: {
            entry: async () => {
              await openPopupPromise('popupTeamIntro', {});
              machine.send('teamIntroClosed');
            },

            on: {
              teamIntroClosed: 'openFriendsMenu',
            },
          },

          openFriendsMenu: {
            entry: () => {
              void services.hand.show({ tag: 'friendsButton', x: 60, y: 50 });
            },

            on: {
              friendsMenuOpened: 'openTeamPopup',
            },
          },

          openTeamPopup: {
            entry: () => {
              void services.hand.show({ tag: 'teamButton', x: 60, y: 50 });
            },
            on: {
              teamPopupOpened: 'openTeamDiscovery',
            },
          },

          openTeamDiscovery: {
            entry: () => {
              void services.hand.show({
                tag: 'teamDiscoveryTab',
                x: 60,
                y: 50,
                zIndex: 10001,
              });
            },
            on: {
              teamDiscoveryOpened: 'completeTutorial',
            },
          },

          completeTutorial: {
            entry: async () => {
              await completeTutorialStep('teams', {
                $stepIndex: 45,
                $stepName: 'create_team',
              });
              await statePromise(() => !PopupMonitor.isOpen('popupTeam'));

              machine.send({ type: 'goToFinal' });
            },

            on: {
              goToFinal: 'final',
            },
          },

          final: {},
        },
      },
      {
        actions: {},
      },
    ),
  );

  return machine;
}

export type TeamTutorialFSM = ReturnType<typeof getTeamsTutorialFSM>;
